export class ListScanJobsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<ScanJob>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListScanJobsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
